import styled from "styled-components";

const ModalContainer = styled.div`
    padding: 15px;
    .form-item {
        input,
        select,
        textarea {
            width: 100%;
            line-height: 2;
            padding: 8px 10px;
            background: #fdfdfd;
            border: solid 1px #cccc;
            border-radius: 5px;
            margin-bottom: 20px;
            font-size: 16px;
            &.disabled {
                pointer-events: none !important;
            }
        }
        input,
        select {
            height: 48px;
        }
        input[type="checkbox"],
        input[type="radio"] {
            height: 15px;
            width: 15px;
            margin-bottom: 0px;
            &:not(:last-child) {
                margin-bottom: 18px;
            }
            + span {
                top: -1.5px;
            }
        }

        .error-msg {
            top: 75px;
        }

        .icon {
            top: 33px;
            right: 13px;
            font-size: 20px;
        }
    }

    .password-field {
        input {
            padding-right: 40px;
        }
    }

    button[type="submit"] {
        min-height: 48px;
        background-color: #333;
        color: #fff;
        font-size: 17px;
        transition: 0.2s;
        min-width: 200px;
        box-shadow: none !important;
    }
`;
export default ModalContainer;
